import React, { FunctionComponent } from 'react';
import { Modal, ModalHeader, ModalFooter, ModalContent, ModalFooterButtons } from 'ui/molecules/modal';
import Translate from 'ui/atoms/translate';
import Hint from 'src/ui/atoms/hint';

export interface DeleteGroupConfirmationModalProps {
  onDelete: () => void;
  onClose: () => void;
  group?: string;
}

const DeleteGroupConfirmationModal: FunctionComponent<DeleteGroupConfirmationModalProps> = (props) => {
  const { onDelete, onClose, group } = props;

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="confirmDeleteGroupModal.title" />
      </ModalHeader>
      <ModalContent>
        <Translate name="confirmDeleteGroupModal.content" args={[<strong>{group}</strong>]} />
        <Hint variant="warning">
          <Translate name="confirmDeleteGroupModal.hint" />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.cancel" />,
              onClick: onClose,
            },
            {
              name: 'delete',
              content: <Translate name="common.delete" />,
              variant: 'primary',
              type: 'submit',
              size: 'large',
              onClick: onDelete,
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteGroupConfirmationModal;
